import SelectButton from '../selectButton'
import { IOptionItem } from 'interfaces'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledSearchInput } from 'styles/styledGlobal'

const StyledSelect = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  &:hover,
  &:focus {
    .search-input,
    .wrap-select-btn {
      border-color: var(--color-primary-108);
    }
  }
`

const StyledSearchIp = styled(StyledSearchInput)`
  height: 40px;
  padding-left: 118px;
  width: 350px;
`
const StyledSelectButton = styled(SelectButton)`
  position: absolute !important;
  margin-left: 2px !important;
  z-index: 2 !important;
  .ant-select-selector {
    height: 36px !important;
  }
`

interface IProps {
  title?: string
  children?: ReactNode
  defaultValue?: IOptionItem
  options?: Array<any>
  onChange?: (value: any) => void
}
const SelectSearch = (props: IProps) => {
  const { options, defaultValue, onChange } = props
  const { t } = useTranslation()
  return (
    <StyledSelect>
      <StyledSelectButton
        options={options}
        color="green"
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <StyledSearchIp
        size="small"
        className="search-input"
        placeholder={t('please-enter-search')}
        suffix={<img src="/images/ic-search.svg" alt="" />}
      />
    </StyledSelect>
  )
}

export default SelectSearch
